<template>
    <td-dialog
        :title="title"
        :before-close="dialogImportDataClose"
        :visible.sync="dialogImportDataVisible"
        width="32%"
        append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-form :model="formUploadExcelInfo" ref="formUploadExcelInfo">
            <el-row>
                <el-col :span="24">
                    <el-form-item>
                        <td-upload
                            :action="importUrl"
                            ref="upload"
                            message="pgCommon.PLEASE_UPLOAD_DATA_CSV"
                            @handResponse="handSuccess"
                            :multiple="false"
                            limit="1"
                            :showFileList="true"
                            accept="CSV"
                            limitSize="10240"
                            :http-request="myUpload"
                        ></td-upload>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer">
            <td-button @click="cancel">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import dataApi from './../assets/api.js';
export default {
    props: ['title', 'dialogImportDataVisible', 'treeNode'],
    created() {},
    // 定义变量
    data() {
        return {
            // UploadExcel表单信息
            formUploadExcelInfo: {
                trusteeshipId: '11111'
            },
            importUrl: '',
            formLabelWidth: '30%'
        };
    },

    // 定义并实现方法体
    methods: {
        // 自定义上传文件方法
        myUpload(content) {
            let file = content.file;
            let fd = new FormData();
            fd.append('multipartFile', file);
            fd.append('trusteeshipId', this.treeNode.sId);
            dataApi.importData(fd, response => {
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/setting/tableDataController/importFromFile', response.message);
                    this.$emit('dialogImportDataClose');
                } else {
                    this.$message({ showClose: true, message: this.$t('pgCommon.UPLOADSUCESSE'), type: 'success' });
                    this.$emit('dialogImportDataClose');
                }
            });
        },

        // 关闭窗口之前需要调用的方法
        dialogImportDataClose() {
            this.$emit('dialogImportDataClose');
        },

        // 取消
        cancel() {
            this.$emit('dialogImportDataClose');
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}
</style>
